// ultraviolet
var ultraViolets = {
  5: "#F7F7FF",
  10: "#F0EFFF",
  20: "#DFDEFF",
  30: "#D0CDFF",
  40: "#B3AEFF",
  50: "#9585FF",
  60: "#775CFF",
  70: "#612FFF",
  80: "#4F00D6",
  90: "#30008F",
  100: "#15005C"
};
// grey
var greys = {
  5: "#FAFBFB",
  10: "#F6F7F8",
  20: "#E8EAED",
  30: "#D7DBE0",
  40: "#B0B6BF",
  50: "#868E98",
  60: "#6C747F",
  70: "#545B63",
  80: "#42474D",
  90: "#2F3237",
  100: "#1A1D21"
};
// green
var greens = {
  5: "#EFFBF3",
  10: "#E0F7E7",
  20: "#CFF9DC",
  30: "#B1FBB1",
  40: "#83DD83",
  50: "#0BEA82",
  60: "#09CC71",
  70: "#08AF61",
  80: "#039450",
  90: "#067F46"
};
// orange
var oranges = {
  5: "#FFF6EF",
  10: "#FFEDE0",
  20: "#FFE1CA",
  30: "#FFD0AD",
  40: "#FFB178",
  50: "#FF8E3C",
  60: "#F27C26",
  70: "#D68100",
  80: "#CA7A01",
  90: "#B87400"
};
// red
var reds = {
  5: "#FFEFEF",
  10: "#FFE0E0",
  20: "#FDC2C2",
  30: "#FFADAD",
  40: "#FF776D",
  50: "#FF4F42",
  60: "#F50C04",
  70: "#E00700",
  80: "#C20303",
  90: "#990000"
};
// teal
var teals = {
  10: "#EBFFF9",
  30: "#B8FFEA",
  50: "#0AFFD4",
  70: "#00ADAD",
  90: "#007A7A"
};
// yellow
var yellows = {
  5: "#FFFBEF",
  10: "#FFF8E0",
  20: "#FFF2C7",
  30: "#FFECAD",
  40: "#FFE376",
  50: "#FFD014",
  60: "#ECBD03",
  70: "#E0BB00",
  80: "#CFAD01",
  90: "#C2A200"
};
// purples
var purples = {
  50: "#D200A3"
};
// pinks
var pinks = {
  50: "#F80F6b"
};
// blues
var blues = {
  5: "#F0F9FF",
  10: "#E0F2FE",
  20: "#BAE6FD",
  30: "#7DD3FC",
  40: "#38BDF8",
  50: "#0EA5E9",
  60: "#0284C7",
  70: "#0369A1",
  80: "#075985",
  90: "#0C4A6E"
};
// basics
var white = "#fff";
var black = "#000";
// legacy
// red
var red = "#FF4F42";
var redLight = "#ffcac6";
var lightRed = redLight; // for backwards compatibility (and all instances of this below)
var redLightest = "#fff1f0";
// yellow
var yellow = "#FFC94C";
var yellowLight = "#ffeec9";
var lightYellow = yellowLight;
var yellowLightest = "#FFF9ED";
// ultraviolet
var ultraViolet = "#612FFF";
var lightUltraViolet = "#E6DEFF";
var ultraVioletLight = lightUltraViolet;
var lightestUltraViolet = "#F9F7FF";
var ultraVioletLightest = lightestUltraViolet;
var ultraviolet30 = "#D9CDFF";
// teal
var teal = "#30808B";
var tealLight = "#C0E8D7";
var lightTeal = tealLight;
var tealLightest = "#DFF4F7";
// green
var green = "#2FB47C";
var lightGreen = "#ebfcf9";
// blue
var blue = "#34BACC";
var lightBlue = "#C2EAF0";
// 50 shades of grey
var ink = "#2A2A2A";
var grey = "#A9A9AE";
var grey30 = "#D7DBE0";
var darkGrey = "#54545E";
var softGrey = "#EBECF0";
var bgGrey = "#F7F7F9";
var flatGrey = "#d1d2d5";
var textDarkGrey = "#212429";
var borderLightGrey = "#e1e7f0";
var greyOnGreyText = "#87878E";
var inputBorder = softGrey;
var inputBorderFocused = ink;
var inputBackground = "#FCFCFD";
// orange
var awOrange = "#ff9800";
var orange = "#FF8E3C";
var lightOrange = "#FDF1E0";
var primary = orange;
// gradients
var orangeGradient1 = ["#ff8439", yellow];
var orangeGradient2 = ["#ff4244", orange];
var redGradient = ["#f80f6b", red];
var pinkGradient = ["#c600ad", "#ff135f"];
var purpleGradient = [ultraViolet, "#d200a3"];
var blueGradient = ["#34ccb7", blue];
var DerpColor = "#fff";
var gradients = [orangeGradient1, orangeGradient2, redGradient, pinkGradient, purpleGradient, blueGradient];
export { DerpColor, awOrange, bgGrey, black, blue, blueGradient, blues, borderLightGrey, darkGrey, flatGrey, gradients, green, greens, grey, grey30, greyOnGreyText, greys, ink, inputBackground, inputBorder, inputBorderFocused, lightBlue, lightGreen, lightOrange, lightRed, lightTeal, lightUltraViolet, lightYellow, lightestUltraViolet, orange, orangeGradient1, orangeGradient2, oranges, pinkGradient, pinks, primary, purpleGradient, purples, red, redGradient, redLight, redLightest, reds, softGrey, teal, tealLight, tealLightest, teals, textDarkGrey, ultraViolet, ultraVioletLight, ultraVioletLightest, ultraViolets, ultraviolet30, white, yellow, yellowLight, yellowLightest, yellows };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
